import React from 'react';
interface DashboardLayoutProps {
  children: React.ReactNode;
  title: string;
}
const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  title
}) => {
  return <div className="min-h-screen pt-20 pb-10 bg-gradient-to-b from-white to-purple-soft">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto rounded-xl shadow-md p-6 md:p-8">
          
          {children}
        </div>
      </div>
    </div>;
};
export default DashboardLayout;